document.addEventListener('DOMContentLoaded', () => {
  const formatMoney = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);

  document.querySelectorAll('[data-cx-gallery]').forEach(gallery => {
    const media = Array.from(gallery.querySelectorAll('.cx-product-media'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-cx-thumb]'));
    const stage = gallery.querySelector('[data-cx-stage]');
    const previous = gallery.querySelector('[data-cx-gallery-previous]');
    const next = gallery.querySelector('[data-cx-gallery-next]');
    let activeIndex = 0;
    let touchStartX = null;

    function showImage(index) {
      if (!media.length) return;
      activeIndex = (index + media.length) % media.length;
      media.forEach((item, itemIndex) => { item.hidden = itemIndex !== activeIndex; });
      thumbs.forEach((thumb, thumbIndex) => thumb.classList.toggle('is-active', thumbIndex === activeIndex));
      if (thumbs[activeIndex]) thumbs[activeIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showImage(index)));
    if (previous) previous.addEventListener('click', () => showImage(activeIndex - 1));
    if (next) next.addEventListener('click', () => showImage(activeIndex + 1));
    if (stage) {
      stage.addEventListener('touchstart', event => { touchStartX = event.changedTouches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', event => {
        if (touchStartX === null) return;
        const distance = event.changedTouches[0].clientX - touchStartX;
        if (Math.abs(distance) > 45) showImage(activeIndex + (distance < 0 ? 1 : -1));
        touchStartX = null;
      }, { passive: true });
    }
  });

  document.querySelectorAll('[data-cx-product]').forEach(section => {
    const form = section.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    const sellingPlan = form.querySelector('[name="selling_plan"]');
    const planDetails = form.querySelector('[data-cx-plan-details]');
    const purchasePlans = form.querySelector('[data-cx-purchase-plans]');
    const planRadios = form.querySelectorAll('[name="purchase_option"]');
    const variantRadios = form.querySelectorAll('[data-cx-variant]');
    const message = section.querySelector('[data-cx-cart-message]');

    function selectedVariant() { return form.querySelector('[data-cx-variant]:checked') || form.querySelector('[data-cx-variant]'); }
    function subscriptionSelected() { return form.querySelector('[name="purchase_option"]:checked')?.value === 'subscribe'; }
    function refreshPrice() {
      const variant = selectedVariant();
      if (!variant) return;
      const allowsSubscription = variant.dataset.allowsSubscription !== 'false';
      if (!allowsSubscription && subscriptionSelected()) {
        const onceRadio = form.querySelector('[name="purchase_option"][value="once"]');
        if (onceRadio) onceRadio.checked = true;
        form.querySelectorAll('.plan-card').forEach(card => card.classList.toggle('is-selected', card.querySelector('input')?.value === 'once'));
      }
      if (purchasePlans) purchasePlans.hidden = !allowsSubscription;
      const once = Number(variant.dataset.price || 0);
      const compare = Number(variant.dataset.compare || once);
      const subscription = Number(variant.dataset.subscriptionPrice || once);
      const current = allowsSubscription && subscriptionSelected() ? subscription : once;
      const set = (selector, value) => { const target = form.querySelector(selector) || section.querySelector(selector); if (target) target.textContent = value; };
      set('[data-cx-once-price]', formatMoney(once));
      set('[data-cx-subscription-price]', formatMoney(subscription));
      set('[data-cx-current-price]', formatMoney(current));
      set('[data-cx-button-price]', formatMoney(current));
      set('[data-cx-compare-price]', formatMoney(compare));
      set('[data-cx-savings]', compare > current ? `SAVE ${Math.round((1 - current / compare) * 100)}%` : '');
      if (sellingPlan) sellingPlan.disabled = !allowsSubscription || !subscriptionSelected();
      if (planDetails) planDetails.hidden = !allowsSubscription || !subscriptionSelected();
    }

    variantRadios.forEach(radio => radio.addEventListener('change', () => {
      form.querySelectorAll('.size-card').forEach(card => card.classList.remove('is-selected'));
      radio.closest('.size-card')?.classList.add('is-selected');
      refreshPrice();
    }));
    planRadios.forEach(radio => radio.addEventListener('change', () => {
      form.querySelectorAll('.plan-card').forEach(card => card.classList.remove('is-selected'));
      radio.closest('.plan-card')?.classList.add('is-selected');
      refreshPrice();
    }));
    refreshPrice();

    form.addEventListener('submit', async event => {
      if (!window.fetch || form.dataset.ajaxCart !== 'true') return;
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      const original = button.innerHTML;
      button.disabled = true;
      button.textContent = 'Adding…';
      try {
       const cartData = new FormData(form);
const chosenVariant = selectedVariant();

if (chosenVariant?.dataset.offer === 'bundle') {
  const pouchVariant = form.querySelector(
    '[data-cx-variant][data-offer="pouch"]'
  );

  if (!pouchVariant) {
    throw new Error('The regular pouch variant could not be found.');
  }

  cartData.set('id', pouchVariant.value);
  cartData.set('quantity', '3');
  cartData.delete('selling_plan');
}

const response = await fetch(
  `${window.Shopify.routes.root}cart/add.js`,
  {
    method: 'POST',
    headers: { Accept: 'application/json' },
    body: cartData
  }
);
        if (!response.ok) { const error = await response.json(); throw new Error(error.description || 'Unable to add this item.'); }
        button.textContent = 'Opening secure checkout…';
        const root = window.Shopify?.routes?.root || '/';
        window.location.assign(`${root}checkout`);
      } catch (error) {
        button.innerHTML = original;
        button.disabled = false;
        if (message) { message.hidden = false; message.textContent = error.message; }
      }
    });
  });
});
